const googleAnalyticsEnabled = (typeof window.ga !== "undefined");
const plausibleEnabled = (typeof window.plausible !== "undefined");

window.FHS = {
    track : function(cat, action, label) {
        cat = cat.trim();
        label = label ? label.trim() : '';
        action = action.trim();
        if (googleAnalyticsEnabled) {
            ga('send', 'event', cat, action, label);
            ga('tbT.send', 'event', cat, action, label);
        }
        if (plausibleEnabled) {
            plausible(cat, {
                props: {
                    action: action,
                    label: label
                }
            });
        } else {
            console.log('tracking', cat, action, label);
        }
    },
    updatePageview: function(uri) {
        if (googleAnalyticsEnabled) {
            ga('set', 'page', uri);
            ga('send', 'pageview');

            ga('tbT.set', 'page', uri);
            ga('tbT.send', 'pageview');
        }
        if (plausibleEnabled) {
            plausible('pageview');
        }
    },
    buttonTrack(selector, cat, action) {
        var buttons = document.querySelectorAll('.topbar__nav-item a');
        [].forEach.call(buttons, function(btn) {
            btn.addEventListener('click', function(e) {
                FHS.track(cat, action, btn.innerText);
            });
        });
    },
    clickTrack(selector, cat, action, label) {
        var btn = document.querySelector(selector);
        if (btn) {
            if (!label) {
                var attrLabel = btn.getAttribute('data-tracking-label');
                if (!attrLabel) {
                    attrLabel = btn.innerText;
                }
                if (attrLabel) {
                    label = attrLabel;
                }
            }
            if (!action) {
                action = btn.getAttribute('href');
            }
            label = label ? label : '';
            action = action ? action : '';
            btn.addEventListener('click', function(e) {
                FHS.track(cat, action, label);
            });
        }
    },
    init: function() {
        // var menuLinks = document.querySelectorAll('.topbar__nav-item a');
        // [].forEach.call(menuLinks, function(link) {
        //     link.addEventListener('click', function(e) {
        //         FHS.track('globalmeny', 'menypunkt', link.innerText);
        //     });
        // });
        FHS.buttonTrack('.topbar__nav-item a', 'globalmeny', 'menypunkt');

        FHS.clickTrack('button.topbar__search', 'globalmeny', 'søk');

        FHS.clickTrack('a.button--blog-cta', 'Call to action blogg');

        // forside
        FHS.clickTrack('.hero__nav a:first-child', 'forside', 'knapp', 'linjer');
        FHS.clickTrack('.hero__nav a:last-child', 'forside', 'knapp', 'skoler');

        // skolesider
        FHS.clickTrack('#school-apply-top', 'Skoleside', 'søk_topp');
        FHS.clickTrack('#school-apply-btm', 'Skoleside', 'søk_bunn');
        FHS.clickTrack('#school-www', 'Skoleside', 'Skolens nettside');
        FHS.clickTrack('#school-www-btm', 'Skoleside', 'Skolens nettside bunn');

        // linjesider
        FHS.clickTrack('#line-apply-top', 'Linjeside', 'søk_topp');
        FHS.clickTrack('#line-apply-btm', 'Linjeside', 'søk_bunn');
        FHS.clickTrack('#line-www-btm', 'Linjeside', 'Skolens nettside');

        var trackItems = document.querySelectorAll('[data-ga-category]');

        [].forEach.call(trackItems, function(item) {
            var category = item.getAttribute('data-ga-category');
            var action = item.getAttribute('data-ga-action');
            var label = item.getAttribute('data-ga-label');
            if (!label) {
                label = item.innerText;
            }
            if (action) {
                item.addEventListener('click', function() {
                    if (item.className.indexOf('accordion__title') > -1 && item.parentNode.className.indexOf('expanded') > -1) {
                        return;
                    }
                    FHS.track(category, action, label);
                });
            }
        });
    }
};

FHS.init();